import {Directive, ElementRef, Renderer, Input } from '@angular/core';

@Directive({
  selector: '[status]',
})
export class StatusDirective {
  constructor(public el: ElementRef, public renderer: Renderer) {
    // el.nativeElement.style.backgroundColor = 'yellow';
  }
  
  ngAfterViewInit() {
    this.renderer.setElementClass(this.el.nativeElement, this.reportStatusClass(this.el.nativeElement.innerHTML), true);
  }

  reportStatusClass = (reportStatusName: string) : string =>  {
    return reportStatusName.replace(' ', '').toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/status.directive.ts